import { render, staticRenderFns } from "./quickBIDesign.vue?vue&type=template&id=62860e9a&"
import script from "./quickBIDesign.vue?vue&type=script&lang=js&"
export * from "./quickBIDesign.vue?vue&type=script&lang=js&"
import style0 from "./quickBIDesign.vue?vue&type=style&index=0&id=62860e9a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports